import type { RichpanelInfo } from '@/features/Setting/Integrations/providers/types';
import { v1ApiClient } from '@/services';

export const richpanelService = {
  async createRichpanelInfo(
    apiKey: string,
    workspaceAlias: string,
  ): Promise<RichpanelInfo> {
    const res = await v1ApiClient.post(
      `/workspaces/${workspaceAlias}/richpanel`,
      {
        api_key: apiKey,
      },
    );
    return res.data;
  },
  async getRichpanelInfo(workspaceAlias: string): Promise<RichpanelInfo> {
    const res = await v1ApiClient.get(
      `/workspaces/${workspaceAlias}/richpanel`,
    );
    return res.data;
  },
  async deleteRichpanelInfo(workspaceAlias: string): Promise<void> {
    await v1ApiClient.delete(`/workspaces/${workspaceAlias}/richpanel`);
  },
  async importRichpanelFeedback(
    workspaceAlias: string,
    dateRange: NullableDateRangeT,
  ): Promise<void> {
    await v1ApiClient.post(`/workspaces/${workspaceAlias}/richpanel/import`, {
      start_date: dateRange.start_date,
      end_date: dateRange.end_date,
    });
  },
};
